// Detects directory-traversal sequences (raw or URL-encoded) in a query string.
export function hasTraversalPayload(search: string): boolean {
  return /\.\.%2f|%2e%2e\/|\.\.\/|%2e%2e%2f/i.test(search);
}
